import mixpanel from 'mixpanel-browser';

// Shared low-level dispatch for first-party mobile analytics.
//
// On the iOS Capacitor build `REACT_APP_QLEARN_DISABLE_THIRD_PARTY_TRACKING=true`
// gates Mixpanel + Hotjar off, but Segment (`window.analytics`) is loaded from
// the hard-coded snippet in public/index.html and still runs inside the WebView.
// So the reliable first-party sink on mobile is `window.analytics.track`; we
// mirror the existing dual-fire (Segment + Mixpanel) so web keeps parity while
// Mixpanel is a harmless no-op on mobile.
//
// This is the single home for the "analytics must NEVER throw into the app
// flow" guarantee — both the IAP funnel and activation instrumentation build on
// it, so the never-throw behavior can't drift between copies. The caller is
// responsible for stamping any base properties before dispatch.

// Dual-fire an already-built event payload to Segment and Mixpanel. Returns
// true if at least one sink accepted it; never throws.
export const dispatchMobileEvent = (event, properties = {}) => {
  if (!event) {
    return false;
  }

  let dispatched = false;

  try {
    if (typeof window !== 'undefined' && typeof window.analytics?.track === 'function') {
      window.analytics.track(event, properties);
      dispatched = true;
    }
  } catch (segmentError) {
    // Analytics must never break the app flow.
  }

  try {
    if (typeof mixpanel?.track === 'function') {
      mixpanel.track(event, properties);
      dispatched = true;
    }
  } catch (mixpanelError) {
    // Analytics must never break the app flow.
  }

  return dispatched;
};

// Strip undefined/null values so we don't ship empty keys into the warehouse.
export const compactProperties = (properties) => {
  const compacted = {};

  Object.keys(properties || {}).forEach((key) => {
    const value = properties[key];

    if (value !== undefined && value !== null) {
      compacted[key] = value;
    }
  });

  return compacted;
};
